import { sanitizeHtml } from '@/utils/safeHtml';

/*
 * SUPPORT-708 (F-034): v-safe-html directive.
 *
 * Drop-in replacement for v-html that routes every payload through the
 * shared sanitizer in @/utils/safeHtml. Use this for any prose/rich-content
 * sink. Never call DOMPurify.sanitize() directly from a component.
 *
 * Lifecycle:
 *  - beforeMount: paint the initial sanitized value into the element so
 *    templates never observe a flash of raw HTML.
 *  - updated: re-sanitize when the bound value changes. Reference equality
 *    on binding.value === binding.oldValue skips work on unrelated re-renders.
 *  - unmounted: not required — Vue clears the element on unmount.
 *
 * Passing null / undefined clears the element (innerHTML = '').
 */

function render(el, value) {
    el.innerHTML = sanitizeHtml(value);
}

export default {
    beforeMount(el, binding) {
        render(el, binding.value);
    },
    updated(el, binding) {
        if (binding.value === binding.oldValue) {
            return;
        }
        render(el, binding.value);
    },
};
